import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Product, ProductName } from "@zp-models/product";

@Component({
  selector: "app-explanation-tile",
  templateUrl: "./explanation-tile.component.html",
  imports: [TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ExplanationTileComponent implements OnInit {
  @Input() isMobileView = false;
  @Input() advicedProduct: Product;
  @Output() orderProduct = new EventEmitter<ProductName>();

  spearpoints: string[] = [];
  constructor(private _translate: TranslateService) {}

  ngOnInit() {
    this._translate
      .get("PRODUCTS." + this.advicedProduct?.name?.toUpperCase() + ".PRODUCT_TILE.SPEARPOINTS")
      .subscribe((translated: Record<string, string>) => {
        this.spearpoints = Object.values(translated);
      });
  }
  get tileIllustrationKey(): string {
    const name = this.advicedProduct?.name?.toUpperCase();
    return name ? `PRODUCTS.${name}.PRODUCT_TILE.ILLUSTRATION` : "";
  }
  get explanationButtonText(): string {
    const name = this.advicedProduct?.name?.toUpperCase();
    return name ? `PRODUCTS.${name}.PRODUCT_TILE.BUTTON_TEXT` : "";
  }
}
